// Homepage video hero. The desktop/mobile source has to be chosen here rather than in the
// markup: `media` on a <source> inside <video> was dropped from the spec and browsers
// ignore it. Loading is deferred until the section nears the viewport — it sits below the
// fold, so nothing here competes with the hero image for bandwidth.

// grep $hp-break in arts/assets/variables.scss
const HP_BREAK = 600;

const initVideoHero = () => {
  const video = document.querySelector('.video-hero video');
  if (!video) return;

  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  const src = window.matchMedia(`(min-width: ${ HP_BREAK }px)`).matches
    ? video.dataset.desktop
    : video.dataset.mobile;
  if (!src) return;

  // iOS only honours autoplay when muted is set as a property, not just an attribute
  video.muted = true;

  const start = () => {
    if (!video.getAttribute('src')) {
      video.setAttribute('src', src);
      video.load();
    }

    const playing = video.play();
    if (playing && playing.catch) playing.catch(() => {});
  };

  if (!window.IntersectionObserver) {
    start();
    return;
  }

  const observer = new window.IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        start();
      } else if (video.getAttribute('src')) {
        video.pause();
      }
    });
  }, { rootMargin: '200px 0px' });

  observer.observe(video);
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initVideoHero);
} else {
  initVideoHero();
}
